import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { getCardDate } from '~/views/dashboard/whats-new-widget/components/card-base/utils';

import * as S from './StreamCard.styles';

export enum CardType {
  CompanyCatalyst,
  MarketCatalyst,
  MarketSummary,
  Scenario,
  EarningsPreview,
  EarningsRecap,
}

export interface StreamCardProps {
  className?: string;
  headerContent: ReactNode;
  cardTitle: ReactNode;
  description: ReactNode;
  leftNode?: ReactNode;
  onClick?: () => void;
  date?: Date;
  variant?: 'default' | 'secondary';
}

export const StreamCard = ({
  className,
  headerContent,
  cardTitle,
  description,
  leftNode,
  onClick,
  date,
  variant = 'default',
}: StreamCardProps) => {
  const { t } = useTranslation(['whatsNew', 'insights']);
  const cardDate = date ?? new Date();

  return (
    <S.Root
      className={className}
      $isHighlighted={false}
      onClick={onClick}
      $isDefaultVariant={variant === 'default'}
    >
      <S.FlexWrapper>
        {leftNode}
        <S.Content>
          <S.HeaderWrapper>{headerContent}</S.HeaderWrapper>
          {cardTitle}
          <S.FooterWrapper>
            <S.Description>{description}</S.Description>
            <S.DateLabel>{getCardDate(cardDate, t)}</S.DateLabel>
          </S.FooterWrapper>
        </S.Content>
      </S.FlexWrapper>
    </S.Root>
  );
};
